import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { SidePanel } from '../../components/side-panel.js';
import { myDefectsApi } from '../../lib/runs-api.js';
import { MyDefectDetails } from './my-defect-details.js';

// #192: Nur-Lesen-Seitenleiste für den Tester. Bewusst eine eigene Komponente statt `DefectDetail`:
// das hängt an den `defect.edit`-Routen (Bearbeitungsfelder, Statusübergänge, Cluster), die ein
// Tester nicht hat. Hier gibt es nichts zu ändern — nur lesen und, am eigenen Defect, eine Notiz
// ergänzen (derselbe Verlaufseintrag wie in „Meine Fehler“).
// #194: Der Inhalt liegt in `MyDefectDetails`; hier nur der SidePanel-Rahmen mit dem Titel. Ohne
// `onOpenTestCase`: keine gestapelten Seitenleisten (der Testfall öffnet nur in der rechten Fläche).
export function MyDefectPanel({
  projectId,
  defectId,
  onClose,
}: {
  projectId: string;
  defectId: string;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  // Gleicher Schlüssel wie in MyDefectDetails — react-query lädt nur einmal.
  const { data: defect, isError: defectError } = useQuery({
    queryKey: ['my-defect', projectId, defectId],
    queryFn: () => myDefectsApi.get(projectId, defectId),
    enabled: Boolean(projectId && defectId),
  });

  // #192: Fehler (404 ohne Leserecht, Netz) nie als ewiges „lädt“ — neutraler Titel plus Wiederholen.
  const title = defect
    ? `${defect.human_id} · ${defect.title}`
    : defectError
      ? t('common.loadFailed.title')
      : t('common.loading');

  return (
    <SidePanel title={title} onClose={onClose}>
      <MyDefectDetails projectId={projectId} defectId={defectId} />
    </SidePanel>
  );
}
